<table class="table table-sm table-bordered mb-0 bg-light small" *ngIf="this.lastItem">
    <thead>
        <tr>
            <td colspan="2">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="flex-grow-1 text-center">현재정보</div>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                운전자
            </td>
            <td>
                {{dtgDriverNm || "-"}}
            </td>
        </tr>
        <tr>
            <td>
                현재위치
            </td>
            <td>
                {{dtgGpsAddr || "-"}}
            </td>
        </tr>
        <tr>
            <td>
                현재속도
            </td>
            <td>
                {{dtgSpeed || "0"}} km/h
            </td>
        </tr>
        <tr>
            <td>
                전압
            </td>
            <td>
                {{dtgBatteryVolt | filterVolt | number:'0.1' || "0"}} v
            </td>
        </tr>
        <tr>
            <td>
                운행거리(오늘/누적)
            </td>
            <td>
                {{dtgDistDaily | filterDist | number:'0.0-3' || "0"}}
                /
                {{dtgDistAccumul | filterDist | number:'0.0-3' || "0"}} km
            </td>
        </tr>
        <!-- <tr>
            <td>
                평균연비
            </td>
            <td>
                홍길동
            </td>
        </tr> -->
    </tbody>
</table>